var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),(_vm.isTruncated)?[_vm._v("...")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }